export default {
	ActivarSlabs(state, accessSlabs) {
        state.token_slabs = accessSlabs.token;
        state.slabs = accessSlabs.login;
    },
    set_slabsStorage(state, val) { 
        state.slabsStorage = val; 
    },     
}
